import { render } from "./ACheckbox.vue?vue&type=template&id=5b5a9f0a"
import script from "./ACheckbox.vue?vue&type=script&lang=js"
export * from "./ACheckbox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__